import { useState } from "react";
import toast from "react-hot-toast";

import { usePatientPrescriptionsByPatientId } from "features/medications/hooks/usePatientPrescriptionsByPatientId";

import { formatPrescriptionContent } from "../utils/formatContent";

export const useInsertPrescription = ({ patientId, onInsert }) => {
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState("");

  const { data: prescriptions, isLoading } = usePatientPrescriptionsByPatientId(patientId);

  const filtered =
    prescriptions?.filter((prescription) => {
      const term = search.toLowerCase();
      return (
        (prescription.note || "").toLowerCase().includes(term) ||
        prescription.medications?.some((med) =>
          (med.tradeName || med.genericName || "").toLowerCase().includes(term)
        )
      );
    }) ?? [];

  const handleInsert = (prescription) => {
    onInsert(formatPrescriptionContent(prescription));
    setShowModal(false);
    setSearch("");
    toast.success("Prescription added to email");
  };

  return {
    showModal,
    openModal: () => setShowModal(true),
    closeModal: () => { setShowModal(false); setSearch(""); },
    search,
    setSearch,
    filtered,
    isLoading,
    handleInsert,
  };
};
